import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { MagmaChartsSiteLink } from "../../../../src/pages/data-visualization/introduction";
import { Flex, FlexBehavior, FlexAlignItems, magma } from 'react-magma-dom';
import { StorybookIcon } from "../../../../src/images/icons/storybook-icon";
import { OpenInNewIcon } from 'react-magma-icons';
import * as React from 'react';
export default {
  LeadParagraph,
  MagmaChartsSiteLink,
  Flex,
  FlexBehavior,
  FlexAlignItems,
  magma,
  StorybookIcon,
  OpenInNewIcon,
  React
};